import React from 'react';
import moment from 'moment-timezone';

interface Props {
  value?: number | null; //ms
  tz?: string;
  format?: string;
}

const Date: React.FunctionComponent<Props> = (props) => {
  if (!props.value) {
    return <div>-</div>;
  }
  let m = moment(props.value);
  if (props.tz) {
    m = m.tz(props.tz);
  }
  return <div {...props}>{m.format(props.format || 'LL')}</div>;
};

export default Date;
